import { h } from "preact";
import RedirectUrl from "../../components/RedirectUrl";


export default function SupportPage(props) {

    return <RedirectUrl url={"https://support.services.verigram.cloud"} />
}